import { useEffect } from "react";
import { useComputedColorScheme } from "@mantine/core";

/**
 * Dynamically loads FlexLayout CSS based on the current Mantine color scheme.
 * Keeps flexlayout-react visually in sync with the Mantine theme toggle.
 */
export function useFlexLayoutTheme() {
  const colorScheme = useComputedColorScheme("dark");

  useEffect(() => {
    const existingLink = document.querySelector('link[href*="flexlayout"]');
    if (existingLink) {
      existingLink.remove();
    }

    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href =
      colorScheme === "dark"
        ? "/node_modules/flexlayout-react/style/dark.css"
        : "/node_modules/flexlayout-react/style/light.css";
    document.head.appendChild(link);

    return () => {
      link.remove();
    };
  }, [colorScheme]);
}
